export default function LoadingComponent(){
    return (
                <div className="spinner-border text-blue text-center m-auto" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
    )
}